import { call, put } from 'redux-saga/effects';
import axios from './axiosHandler';
import { API_HOST } from '../env';
import sagaLoading from './sagaLoading';
import sagaGetAllCoupons from './sagaGetAllCoupons';
import { MESSAGE_ERROR, MESSAGE_SUCCESS } from '../actions/actionTypes';

export default function* sageUpdateCoupon({ data }) {
  const updateData = new FormData();
  // eslint-disable-next-line
  // updateData.set('id', data['_id']);
  updateData.set('code', data.code);
  updateData.set('membershipId', data.membershipId);
  updateData.set('useLimit', data.useLimit);
  try {
    yield call(sagaLoading, true);
    yield call(() =>
      axios({
        url: `${API_HOST}coupon/create`,
        method: 'post',
        data,
      }).then((response) => response.data)
    );
    yield call(sagaGetAllCoupons);
    yield put({ type: MESSAGE_SUCCESS, payload: 'Updated successfully' });
    yield call(sagaLoading, false);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
    yield call(sagaLoading, false);
    yield put({
      type: MESSAGE_ERROR,
      payload: error.message ? error.message : 'There is something wrong, please, try again.',
    });
  }
}
